module.exports = __webpack_public_path__ + "static/img/A-apple.7af484a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/A-apple.png
// module id = 3GzK
// module chunks = 1